document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('.toggle-button').addEventListener('click', function() {
        var container = document.querySelector('.pdp-product-facts');
        container.classList.toggle('expanded');
        if (container.classList.contains('expanded')) {
            this.textContent = 'Show Less';
        } else {
            this.textContent = 'Show More';
        }
    });
});
